import {createApp, h} from 'vue';
import App from '../app.vue';
import router from '../router.js';
import store from '../store/store.js';
import {i18n, loadLanguageAsync} from '../startup/i18n.js';
import {initSoundNotification} from '../startup/soundNotification.js';
import '../startup/dayjs.js';// https://day.js.org/ru/ альтернатива moment.js которая весит всего 2кб
import {installGlobals} from '../startup/injections.js'; // Глобальные свойства ($bus, toggleNoScroll)
import {installDirectives} from '../startup/directives.js';// Кастомные директивы
import {installBaseComponents} from '../startup/baseComponents.js';// Добавление базовых компонентов (которые начинаются на Base*) в глобвльную область видимости
import ResizeObserverComponent from '../components/ResizeObserverComponent.vue';
import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';
import '../../../stylesheets/refactoring/common.scss';// Некоторые базовые глобальные стили

import {ROUTE_PATHS} from '../const.js';

const langPromise = loadLanguageAsync();// Загрузка и установка локализации. Промис, делается асинхронно

const start = () => {
  if (window.current_user) {
    initSoundNotification();
  }
  langPromise.then(()=>{
    // $root.routesList читают футер-компоненты; hints обязан быть объявлен в data —
    // TheMainLayout пишет window.vm.hints, а писать можно только в объявленные поля.
    const app = createApp({
      data() {
        return {
          routesList: ROUTE_PATHS,
          hints: null,
        };
      },
      render: () => h(App),
    });

    app.use(router).use(store).use(i18n);
    app.use(FloatingVue, {
      disposeTimeout: 1000,
      themes: {tooltip: {html: true}},
    });
    app.component('resize-observer', ResizeObserverComponent);
    installGlobals(app);
    installDirectives(app);
    installBaseComponents(app);

    window.vm = app.mount('#root');
  });
};

// Слушатель DOMContentLoaded, добавленный после срабатывания события, не выполнится —
// локаль грузится асинхронно, поэтому проверяем readyState.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start);
} else {
  start();
}
